export default __webpack_public_path__ + "static/media/copy.ad5d2c89.svg";